import { render, staticRenderFns } from "./newTypeReport.vue?vue&type=template&id=47846a54&"
import script from "./newTypeReport.vue?vue&type=script&lang=js&"
export * from "./newTypeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports